/**
 * Wspolne zod patterns - email, UUID, image data URL, VariantType.
 */
import { z } from "zod";

export const UuidSchema = z.string().regex(
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  "Invalid UUID",
);

export const EmailSchema = z.string().email().toLowerCase();

export const ImageDataUrlSchema = z
  .string()
  .startsWith("data:image/", "Must be image data URL");

export const VariantTypeSchema = z.enum([
  // Aktualne nazwy DB (CHECK constraint na processing_jobs.tool_type)
  "virtual_staging",
  "decluttering",
  "team_photo",
  "plot_visualization",
  "arranged",
  "empty_room_arrangement",
]);
